module.exports = __webpack_public_path__ + "img/Ardunic Elements-03.ed1ec950.svg";